import { CtaButtonType, CtaForm } from '@pairy/sheard/types';

import { GetBulkFilePreviewResponse } from '../../../types/file';
import { EmbedItemType, MessageBoxItemType } from '../../PdfViewer/index.types';
import { adaptBulkPreviewDocument } from '../index.types';
import V2ViewerShell from '../V2ViewerShell';

interface Props {
  data?: GetBulkFilePreviewResponse;
  messageBoxItems?: MessageBoxItemType[];
  embedItems?: EmbedItemType[];
  ctaButtonList?: CtaButtonType[];
  ctaForm?: CtaForm;
  translateKoToEn: (item: string) => string;
}

/** 벌크 공유 PDF의 V2 관리자 미리보기 진입점(수신자 화면과 동일 UI) */
const V2BulkPreview = ({
  data,
  messageBoxItems,
  embedItems,
  ctaButtonList,
  ctaForm,
  translateKoToEn,
}: Props) => {
  if (!data) {
    return null;
  }

  return (
    <V2ViewerShell
      document={adaptBulkPreviewDocument(data)}
      isBulk
      isPreview
      domain={data.user.domain}
      messageBoxItems={messageBoxItems}
      embedItems={embedItems}
      cta={{
        ctaForm,
        ctaButtonList,
        isEmailVerificationEnabled: data.file.isEmailVerificationEnabled,
        isFormSubmitted: false,
      }}
      translateKoToEn={translateKoToEn}
    />
  );
};

export default V2BulkPreview;
